import { RouteConfig } from 'vue-router'

const Auth = () => import('../../views/student/Auth.vue')

export const authRoute: RouteConfig = {
  path: '/student/auth',
  name: 'student_auth',
  component: Auth,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '身份认证',
  },
}

export default [authRoute]
